// react
// dependencies
import { Map } from "immutable";
import React from "react";
import { connect } from "react-redux";

// components
import CreateForm from "../../../../containers/Forms";

// actions
import { changeFormInput } from "../actions";

// selectors
import { getFormInputs } from "../selectors";

import PropTypes from "../../../../lib/prop-types";

// config
import Config from "../Config";

class CreateWorkflowForm extends React.Component {
	static propTypes = {
		changeState: PropTypes.func.isRequired,
		inputValues: PropTypes.instanceOf(Map).isRequired,
	};

	static defaultProps = {};

	handleChange = (name, value) => {
		this.props.changeState(name, value);
	};

	render() {
		const { inputValues } = this.props;
		const formWidth = 440;

		const formInputs = Config.inputs.map((input) => {
			const inputProps = input.props;

			if (inputProps && inputProps.width) {
				inputProps.width = formWidth;
			}

			return {
				...input,
				name: input.key,
				value: inputValues.get(input.key, input.defaultValue),
				onChange: (value) => this.handleChange(input.key, value),
			};
		});

		return (
			<section className="mx-auto pt-[30px]" style={{ width: formWidth }}>
				<CreateForm
					formIcon={["fas", "exchange"]}
					formName="Launch Workflow"
					formDescription="Define the basic setup for the workflow you want to assign."
					inputs={formInputs}
				/>
			</section>
		);
	}
}

const mapStateToProps = (state) => ({
	inputValues: getFormInputs(state),
});

const mapDispatchToProps = (dispatch) => ({
	changeState: (name, value) => dispatch(changeFormInput(name, value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateWorkflowForm);
